/** Read width/height from an image file in the browser before upload. */
export function readImageFileDimensions(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Unable to read image dimensions.'));
    };

    img.src = url;
  });
}

export function formatBannerSizeError(required, actual) {
  return `Banner must be exactly ${required.width} × ${required.height}px. Your image is ${actual.width} × ${actual.height}px.`;
}

export function isBannerSizeValid(required, actual) {
  return actual.width === required.width && actual.height === required.height;
}
